import { render } from "./News01.vue?vue&type=template&id=7a7c02ec&scoped=true"
import script from "./News01.vue?vue&type=script&lang=js"
export * from "./News01.vue?vue&type=script&lang=js"

import "./News01.vue?vue&type=style&index=0&id=7a7c02ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7c02ec"]])

export default __exports__